import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { CookiesPage } from "@/components/pages/CookiesPage";
import { fr } from "@/i18n/fr";

export const Route = createFileRoute("/cookies")({
  head: () =>
    buildHead({
      lang: "fr",
      page: "home",
      title: fr.cookies.page.title + " · 2AM Hospitality",
      description: fr.cookies.page.intro,
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "fr") i18n.changeLanguage("fr");
    }, []);
    if (i18n.language !== "fr") i18n.changeLanguage("fr");
    return <CookiesPage />;
  },
});
